import type { ZonaDepartamento } from "../types";

export const DEPARTMENT_ZONES: ZonaDepartamento[] = [
  {
    nombre: "Centro",
    departamentos: [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12A",
      "12B",
      "14",
      "15",
      "16",
      "17",
      "18",
    ],
  },
  {
    nombre: "Loma",
    departamentos: ["19", "20", "21", "22", "23", "24", "25", "26", "27"],
  },
];
